const PRIORITY_TASK_ALLOCATION_TYPE = {
  TIER_ONE: {
    label: 'Tier One',
    value: 'TIER_ONE',
  },
  TOP_200: {
    label: 'Top 200 Curation',
    value: 'TOP_200',
  },
  CHAD_CURATION: {
    label: 'CHAD Curation',
    value: 'CHAD_CURATION',
  },
}

export default PRIORITY_TASK_ALLOCATION_TYPE
